import { classNames } from '@commenda/utils';
import React from 'react';

const FieldWrapper = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    _className?: string;
    id?: string;
  }
>(({ children, _className, id }, ref) => {
  return (
    <div
      id={id}
      className={classNames('flex flex-col gap-1.5', _className || '')}
      ref={ref}
    >
      {children}
    </div>
  );
});

FieldWrapper.displayName = 'FieldWrapper';

export default FieldWrapper;
